import { Link } from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import React from 'react'
import { useHistory } from 'react-router-dom';

const GenericNotFound = () => {
    const history = useHistory()
    return (
        <div>
            <Alert severity="warning">
                <AlertTitle>Error 404</AlertTitle>
                Página no encontrada
                <br/>
                <Link component="button" variant="body2" onClick={() => { history.push('/') }}>
                    Volver al inicio
                </Link>
            </Alert>
        </div>
    )
}

export default GenericNotFound